import { defineStore } from 'pinia';

import type { AlgoliaSearchStoreInterface } from './types';

const useAlgoliaSearchStore = defineStore('algoliaSearch', {
  state: (): AlgoliaSearchStoreInterface => ({
    isSearchModalOpen: false,
    isTrendingNowBlockOnSearchPageEnabled: false,
    searchTerm: '',
    searchInstance: null
  }),
  getters: {
    getSearchModalOpen: (state) => state.isSearchModalOpen,
    getTrendingNowBlockOnSearchPageEnabled: (state) => state.isTrendingNowBlockOnSearchPageEnabled,
    getSearchTerm: (state) => state.searchTerm
  },
  actions: {
    setSearchModalOpen(value: boolean) {
      this.isSearchModalOpen = value;
    },
    setTrendingNowBlockOnSearchPageEnabled(value: boolean) {
      this.isTrendingNowBlockOnSearchPageEnabled = value;
    },
    setSearchTerm(searchTerm: string) {
      this.searchTerm = searchTerm;
    },
    setSearchInstance(instance: any) {
      this.searchInstance = instance;
    },
    search(query: string) {
      if (this.searchInstance?.helper) {
        this.searchInstance.helper.setQuery(query).search();
      }
    }
  }
});

export default useAlgoliaSearchStore;
